<template>
  <div v-show="render">
    <div role="alert" class="alert alert-info">
      <p class="mb-0">
        A teacher growth score of 80 means, on average, students rostered to that teacher are meeting expected growth. 
        <br>
        A growth score higher than 80 means that teacher's students are growing more than expected on average, and a growth score below 80 means that teacher's students are growing less than expected on average. 
        <br>
        
        Student growth scores show us if a student learned as much as we expected them to learn in a year. Student growth scores are calculated by DESE using students' prior assessment score history.
        <br>
        Measuring students' growth reinforces the idea that all students can learn and can demonstrate learning regardless of where they are on the achievement continuum. Visit the Classroom Value-Added Growth module under the Academics tab to learn more about the growth scores of individual students rostered to each teacher
      </p>
    </div>
    <div class="chart">
      <teacher-composite-table />
    </div>
  </div>
</template>

<script>
import { LeaTypes } from '@/helpers/leaTypes';
import TeacherCompositeTable from '../tables/TeacherCompositeTable.vue'

export default {
  props: {
    render: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TeacherCompositeTable
  },
  data() {
    return {
      LeaTypes
    }
  },
}
</script>

<style type="text/css">
.clear-pad {
  clear: right;
  margin-top: 2em;
}
</style>